module.exports = __webpack_public_path__ + "img/complete.d9547ec9.png";